<template>
  <router-view />
</template>

<script>
export default {
  name: 'Notifications'
};
</script>

<style scoped></style>
